import { Loading } from '@mostrans/web-components/components/base/Loading';
import React from 'react';

function DownloadingResources() {
  return (
      <div
          style={{
              position: "fixed",
              bottom: "0",
              right: "0",
              zIndex: "900000",
          }}
          className="bg-white d-flex align-items-center justify-content-start gap-50 p-25"
      >
          <Loading size="1rem" />
          <small>Downloading resources...</small>
      </div>
  );
}

export default DownloadingResources